import { PaginationModel } from "@/shared/models/PaginatorModel.ts";

export class NotificationsModel {
  public id: number | string;

  public createdAt: string;

  public type: number;

  public message: string;

  public read: boolean;

  constructor(data: Partial<NotificationsModel> = {}) {
    this.id = data.id ?? 0;
    this.createdAt = data.createdAt ?? "";
    this.type = data.type ?? 0;
    this.message = data.message ?? "";
    this.read = data.read ?? false;
  }
}

export class NotificationsTotalNotReadModel {
  public totalNotRead: number;

  constructor(data: Partial<NotificationsTotalNotReadModel> = {}) {
    this.totalNotRead = data.totalNotRead ?? 0;
  }
}

export class NotificationsPaginatedModel extends PaginationModel {
  constructor(data: Partial<PaginationModel> = {}) {
    data.content = Array.isArray(data.content)
      ? data.content?.map((item: NotificationsModel) => new NotificationsModel(item))
      : [];

    super(
      data.content,
      data.pageable,
      data.totalElements,
      data.totalPages,
      data.last,
      data.size,
      data.number,
      data.sort,
      data.first,
      data.numberOfElements,
      data.empty,
    );
  }
}
